import React from 'react'
import PropTypes from 'prop-types'
import { PillsWrapper, StyledPill, StyledLink } from './styles'

const SimilarAiPills = ({ similarAiLinksData }) => {
  if (similarAiLinksData?.default?.length > 0) {
    return (
      <>
        <div data-test='similar-ai-links' className='xs-block'>
          <h2>Related categories</h2>
          <PillsWrapper>
            {similarAiLinksData.default.map(link => (
              <StyledPill key={link.url} label={link.name} href={link.url} />
            ))}
          </PillsWrapper>
        </div>
        {similarAiLinksData?.deeper?.length > 0 && (
          <div data-test='similar-ai-popular-links' className='xs-block'>
            <h2>Popular filters</h2>
            <PillsWrapper>
              {similarAiLinksData.deeper.map(link => (
                <StyledLink key={link.url} href={link.url}>
                  {link.name}
                </StyledLink>
              ))}
            </PillsWrapper>
          </div>
        )}
      </>
    )
  }

  return null
}

SimilarAiPills.propTypes = {
  similarAiLinksData: PropTypes.shape({
    default: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired
      })
    ).isRequired,
    deeper: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired
      })
    )
  })
}

SimilarAiPills.defaultProps = {
  similarAiLinksData: {
    default: [],
    deeper: []
  }
}

export default SimilarAiPills
